var exports = {
  "WB": "FavoritesWelcomeSection.module__welcomeSection___dzROSX",
  "r2": "FavoritesWelcomeSection.module__iconSection___dzROSX",
  "P0": "FavoritesWelcomeSection.module__iconWrapper___dzROSX",
  "Kk": "FavoritesWelcomeSection.module__icon___dzROSX",
  "Jo": "FavoritesWelcomeSection.module__contentSection___dzROSX",
  "R_": "FavoritesWelcomeSection.module__heading___dzROSX",
  "h_": "FavoritesWelcomeSection.module__description___dzROSX",
  "uN": "FavoritesWelcomeSection.module__tip___dzROSX",
  "A2": "FavoritesWelcomeSection.module__actionSection___dzROSX",
};

module.exports = exports;
